module.exports = __webpack_public_path__ + "static/media/comingSoon.6c20ed17.png";